import Swiper from 'swiper';
import { Navigation, Grid } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/grid';

export default function reviewSlider() {
	const slider = new Swiper(".js-reviewSlider", {
		modules: [Navigation, Grid],
		slidesPerView: 1,
		spaceBetween: 24,
		autoHeight: true,
		navigation: {
			prevEl: ".js-reviewPrev",
			nextEl: ".js-reviewNext",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				autoHeight: false,
				grid: {
					rows: 2,
					fill: "row",
				},
			},
			1024: {
				slidesPerView: 3,
				autoHeight: false,
				grid: {
					rows: 2,
					fill: "row",
				},
			}
		}
	});

	return slider;
}